import React, { ReactNode, useEffect, useRef, useState } from "react";
import { Add } from "@mui/icons-material";
import { Box, Fab, Grow, Stack } from "@mui/material";

interface IFabMenu {
  children: ReactNode[];
}

const FabMenu: React.FC<IFabMenu> = ({ children }) => {
  const ref = useRef<HTMLDivElement>();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.addEventListener("click", (event) => {
      const element: any = event.target;
      if (!ref.current?.contains(element) && open) {
        setOpen(false);
      }
    });
  }, [open]);

  return (
    <Box
      ref={ref}
      sx={(theme) => ({
        position: "fixed",
        bottom: 20,
        right: 20,
        zIndex: theme.zIndex.fab,
      })}
    >
      <Grow in={open} unmountOnExit>
        <Stack
          spacing={1}
          sx={{ position: "absolute", right: 0, mb: 1, bottom: "100%" }}
        >
          {children}
        </Stack>
      </Grow>
      <Fab
        size="small"
        color="primary"
        onClick={() => {
          setOpen((o) => !o);
        }}
      >
        <Add
          sx={(theme) => ({
            transform: `rotate(${open ? 45 : 0}deg)`,
            transition: theme.transitions.create("transform"),
          })}
        />
      </Fab>
    </Box>
  );
};

export default FabMenu;
